import { DocRole, FolderRole } from '@affine/graphql';
import type { useI18n } from '@affine/i18n';

type TFunc = ReturnType<typeof useI18n>;

export const OBJECT_ROLE_LABEL_KEYS: Record<string, string> = {
  [DocRole.Manager]: 'com.streamlain.share-menu.option.permission.can-manage',
  [FolderRole.Admin]: 'com.streamlain.share-menu.option.permission.can-manage',
  [DocRole.Editor]: 'com.streamlain.share-menu.option.permission.can-edit',
  [DocRole.Reader]: 'com.streamlain.share-menu.option.permission.can-read',
  [DocRole.None]: 'com.streamlain.share-menu.option.permission.no-access',
};

export function objectRoleLabel(t: TFunc, role: string): string {
  const key =
    OBJECT_ROLE_LABEL_KEYS[role] ??
    `com.streamlain.settings.workspace.permissions.role.${role.toLowerCase()}`;
  return t[key as keyof typeof t]?.() ?? role;
}
